import React from 'react';
import PropTypes from 'prop-types';

import { FormattedMessage } from 'react-intl';

import Clickable from '../../../../components/clickable/Clickable';

import styles from './selector.module.scss';
import checklistStyles from '../../complete/components/InspectionChecklist/checklist.module.scss';
import { checkChecklistCondition } from '../../InspectionUtils';

const Selector = ({
  form,
  activeInspectionField,
  answers,
  changeSelectedField,
  columnDetails,
  supplementInspection,
  selected_checklist,
  url
}) => {
  const fieldIds = form?.sections[1]?.fields;
  let fields = form?.fields;

  if (supplementInspection && selected_checklist.length > 0) {
    fields = selected_checklist;
  }
  let titles = {
    checklist: { id: 'inspections.answer_details.inspection_checklist', default: 'Inspection Checklist' }
  };
  if (url?.includes('sms')) {
    titles = {
      checklist: { id: 'safetyAudits.answer_details.audit_checklist', default: 'Audit Checklist' }
     };
  }
  return (
    <div>
      {form?.groups ? (
      form.groups.map(group => (
        <div key={group?.id} className={styles.selector}>
          <div className={`${styles.item} ${styles.title}`}>{group.title}</div>
          {fieldIds?.map((fieldId) => {
            const checklistField = fields?.find(
              field => field.id === fieldId
            );
            if (checklistField) {
              const checklist_length = Object.keys(
                  checklistField?.checklist?.filter(
                    item => checkChecklistCondition(item, answers)
                  )
              ).length;
              let allTrue = (answers[checklistField.id]
                    && Object.values(answers[checklistField.id]))
                  || [];
              if (columnDetails && columnDetails.length > 0) {
                const result = allTrue.map(f => !Object.values(f).includes(false));
                allTrue = !result.includes(false);
              } else if (allTrue && allTrue.length > 0) {
                allTrue = allTrue.reduce((a, b) => a && b);
              }
              let status = allTrue
                ? checklistStyles.success
                : checklistStyles.failure;
              const groupCheckList = group.fields.filter(
                grpfieldId => grpfieldId === checklistField.id
              );
              let field = '';
              if (groupCheckList.length > 0 && checklist_length > 0) {
                field = (
                  <Clickable
                    className={`${styles.item} ${
                      checklistStyles.inspectionChecklist
                    } 
                    ${fieldId === activeInspectionField ? styles.active : ''}`}
                    onClick={() => changeSelectedField(fieldId)}
                    key={fieldId}
                  >
                    <span className={`${checklistStyles.statusDot} ${status}`} />
                    <div className={styles.titleContainer}>
                      {checklistField.title}
                    </div>
                  </Clickable>
                );
              }
              return <>{field} </>;
            }
            return '';
          })}
        </div>
      ))
    ) : (
      <div className={styles.selector}>
        <div className={`${styles.item} ${styles.title}`}>
            <FormattedMessage
              id={titles.checklist.id}
              defaultMessage={titles.checklist.default}
            />
        </div>
        {fieldIds?.map((fieldId) => {
          const checklistField = fields?.find(
            field => field.id === fieldId
          );
          const checklist_length = Object.keys(
            checklistField?.checklist?.filter(
              item => checkChecklistCondition(item, answers)
            )
          ).length;
          let allTrue = answers[checklistField.id]
            && Object.values(answers[checklistField.id]);
          if (columnDetails && columnDetails.length > 0) {
            const result = allTrue.map(f => !Object.values(f).includes(false));
            allTrue = !result.includes(false);
          } else if (allTrue && allTrue.length > 0) allTrue = allTrue.reduce((a, b) => a && b);
          const status = allTrue
            ? checklistStyles.success
            : checklistStyles.failure;
          let field = '';
          if (checklist_length > 0) {
            field = (
              <Clickable
                className={`${styles.item} ${
                  checklistStyles.inspectionChecklist
                } 
                ${fieldId === activeInspectionField ? styles.active : ''}`}
                onClick={() => changeSelectedField(fieldId)}
                key={fieldId}
              >
                <span className={`${checklistStyles.statusDot} ${status}`} />
                <div className={styles.titleContainer}>
                  {checklistField.title}
                </div>
              </Clickable>
            );
          }
          return <>{field} </>;
        })}
      </div>
    )}
    </div>
  );
};

Selector.propTypes = {
  form: PropTypes.shape().isRequired,
  activeInspectionField: PropTypes.string.isRequired,
  answers: PropTypes.shape({}).isRequired,
  changeSelectedField: PropTypes.func.isRequired
};

export default Selector;
